export const visitConfig = {
  home: {
    module: '首页',
    page: '首页'
  },
  lifeManager: {
    module: '良渚生命科技平台',
    page: '良渚生命科技平台'
  },
  cultureManager: {
    module: '良渚数字文化平台',
    page: '良渚数字文化平台'
  },
  designManager: {
    module: '良渚工业设计平台',
    page: '良渚工业设计平台'
  },
  hall: {
    module: '办事大厅',
    page: '办事大厅介绍'
  },
  goSea: {
    module: '出海服务',
    page: '文化企业出海知识产权保护'
  },
  konwledge: {
    module: '知识产权交易',
    page: '公共版权池'
  },
  policyInfo: {
    module: '政策资讯',
    page: '知识产权政策'
  },
  brandManager: {
    module: '品牌指导',
    page: '重点商标展示'
  },
  assessment: {
    module: '专利预评估',
    page: '专利预评估'
  },
  dataCenter: {
    module: '数据中心',
    page: '数据中心'
  }
}

export const menuConfig = {
  homeImage: '首页轮播图管理',
  lifeManagerInfo: '生命科技平台-介绍',
  lifeManagerPolicy: '生命科技平台-小镇介绍',
  lifeManagerMedicine:'生命科技平台-生物医药时政信息',
  cultureManagerInfo: '数字文化平台-介绍',
  cultureManagerIndustry: '数字文化平台-产业数据',
  designManagerInfo: '工业设计平台-介绍',
  designManagerPolicy: '工业设计平台-小镇政策',
  hallInfo: '办事大厅-介绍',
  hallUp: '办事大厅-办事指南-线上',
  hallDown: '办事大厅-办事指南-线下',
  hallHandle: '办事大厅-一站式办理',
  hallFree: '办事大厅-免费服务',
  hallRapidPatentPreTrial: '办事大厅-专利快速预审',
  hallIprCustody: '办事大厅-知识产权托管',
  hallIprFinancialService: '办事大厅-知产金融服务',
  hallComplaint: '办事大厅-投诉建议',
  seaPicCom: '出海服务管理-海外预警',
  seaWHQYCKZSBQBHEJCD: '文化企业出口知识产权保护二级菜单',
  seaWHQYCKZSBQBH: '出海服务管理-文化企业出口知识产权保护',
  seaHWJFJJ: '出海服务管理-海外纠纷救济',
  seaGJDWWHMY: '出海服务管理-国家对外文化贸易基地(杭州)活动资讯',
  seaHWZHZSCQ: '出海服务管理-海外展会知识产权保护',
  seaKJDSJFCL: '出海服务管理-跨境电商纠纷处理',
  seaLZQYHWZSCQ: '出海服务管理-良渚企业海外知识产权保护案例',
  seaZJK: '出海服务管理-专家库',
  seaJGK: '出海服务管理-机构库',
  konwledgePublic: '公共版权池',
  knowledgeZSCQ:'知识产权市集',
  knowledgePublicType: '公共版权池作品类型',
  knowledgeZSCQType: '知识产权市集作品类型',
  policyInfoZSCQZC: '政策资讯-知识产权政策',
  policyInfoZSCQFG: '政策资讯-知识产权法规',
  policyInfoClassType: '政策资讯管理-知识产权课程类型',
  policyInfoClass: '政策资讯-知识产权课程',
  brandManager: '品牌管理',
  brandType: '品牌分类',
  linkManager: '友情链接'
}



// WEBPACK FOOTER //
// ./src/assets/static/apiConfig.js